import { call } from "../../../util/misc";
import { extractLabelFields } from "../../../util/labelFields";

/**
 * Read a photographed carton label into fields, and match it to a sale item.
 *
 * The parse sits on this side on purpose. Gemini is asked for a transcription
 * rather than an extraction -- a model asked for a PO will always produce one,
 * and the PO is the field that resolves a sale outright -- so the text comes
 * back raw and src/util/labelFields.js turns it into fields with the declining
 * behaviour it was measured for. Doing that here also means the receiver can be
 * shown what was read before anything is claimed about it.
 */

/** Photo in, verbatim label text out. The slow half. */
export const TRANSCRIBE_LABEL = async (context, { imageBase64, mimeType }) => {
  const { text } = await call("transcribeLabel", { imageBase64, mimeType });
  return text;
};

/**
 * Text in, fields plus ranked sale items out.
 *
 * Returns the fields even when no PO resolved, because "this is a Kolbe label
 * and here is what it says" is worth showing a receiver holding a carton the
 * app cannot place.
 */
export const READ_LABEL = async ({ dispatch }, { text }) => {
  const fields = extractLabelFields(text);
  if (!fields.po) return { fields, match: null };
  const match = await call("matchLabelFields", { fields });
  return { fields, match };
};

/** Photo straight through to a match, for the ordinary scan path. */
export const SCAN_LABEL = async ({ dispatch }, { imageBase64, mimeType }) => {
  const text = await dispatch("TRANSCRIBE_LABEL", { imageBase64, mimeType });
  const read = await dispatch("READ_LABEL", { text });
  return { text, ...read };
};

/**
 * Credit the scanned cartons against the slip they belong to.
 *
 * The same completeReceiving every other receiving flow uses -- a carton that
 * is one panel of a door carries `component`, and the fold there turns five of
 * them into one door rather than five.
 */
export const COMPLETE_LABEL_RECEIVING = async (
  context,
  { projectID, saleID, orderID, packingSlipID, receivedItems }
) => {
  return call("completeReceiving", {
    projectID,
    saleID,
    orderID,
    packingSlipID,
    receivedItems,
    backorderedItemIds: [],
    // A pallet is not a slip: scanning some of a slip's cartons says nothing
    // about whether the rest arrived, so completeness is never inferred here.
    receivedComplete: false,
  });
};
